import {
  aggregate,
  createItem,
  createItems,
  createUser,
  deleteFile,
  deleteItem,
  deleteItems,
  readField,
  readFile,
  readFiles,
  readItem,
  readItems,
  readMe,
  readNotifications,
  readUser,
  readUserPermissions,
  readUsers,
  createComment as sdkCreateComments,
  readComments as sdkReadComments,
  triggerFlow,
  updateFile as sdkUpdateFile,
  updateItem,
  updateItems,
  updateNotification,
  updateNotifications,
  updateUser,
  uploadFiles,
  readFolders,
  readFolder,
  readItemPermissions,
  customEndpoint,
} from "@directus/sdk";
import client from "./client";
import { handleDirectusResponse } from "./middleware";
export { customEndpoint };

export async function fetchCurrentUserData(query) {
  try {
    const response = await client.request(readMe(query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

// Directus core comments wrappers
export async function readComments(query) {
  try {
    const response = await client.request(sdkReadComments(query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function createComments(item, query) {
  try {
    const response = await client.request(sdkCreateComments(item, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}
export async function fetchUser(key, query) {
  try {
    const response = await client.request(readUser(key, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function addUser(item, query) {
  try {
    const response = await client.request(createUser(item, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

// export async function updateUser(key, item, query) {
//   try {
//     const response = await client.request(updateUser(key, item, query));
//     return handleDirectusResponse(response);
//   } catch (error) {
//     console.log(error);
//     let mutedError = handleDirectusResponse(error);
//     throw mutedError;
//   }
// }

export async function fetchUsers(query) {
  try {
    const response = await client.request(readUsers(query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function fetchItems(collection, query) {
  try {
    const response = await client.request(readItems(collection, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function fetchFolders(query) {
  try {
    const response = await client.request(readFolders(query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}
export async function fetchFolder(id, query) {
  try {
    const response = await client.request(readFolder(id, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function fetchFiles(query) {
  try {
    const response = await client.request(readFiles(query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function fetchFile(id, query) {
  try {
    const response = await client.request(readFile(id, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function updateFile(id, item, query) {
  try {
    const response = await client.request(sdkUpdateFile(id, item, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function fetchItemsWithFlow(flowId, query) {
  try {
    const response = await client.request(triggerFlow("GET", flowId, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function fileUpload(formData) {
  try {
    const response = await client.request(uploadFiles(formData));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function updateDirectusUser(key, item, query) {
  try {
    const response = await client.request(updateUser(key, item, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function getItemFromCollection(collection, id, query) {
  try {
    const response = await client.request(readItem(collection, id, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getItemsFromCollection(collection, query) {
  try {
    const response = await client.request(readItems(collection, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function getNotificationsFromDirectus(query) {
  try {
    const response = await client.request(readNotifications(query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function aggregateItemsFromCollection(collection, query) {
  try {
    const response = await client.request(aggregate(collection, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function addItemToCollection(collection, item, query) {
  try {
    const response = await client.request(createItem(collection, item, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function addItemsToCollection(collection, items, query) {
  try {
    const response = await client.request(
      createItems(collection, items, query),
    );
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function updateItemInCollection(collection, id, item, query) {
  try {
    const response = await client.request(
      updateItem(collection, id, item, query),
    );
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function updateItemsInCollection(collection, items, query) {
  try {
    const response = await client.request(
      updateItems(collection, items, query),
    );
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function updateNotificationStatus(id, status) {
  try {
    const response = await client.request(updateNotification(id, { status }));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function updateNotificationsStatus(ids, status) {
  try {
    if (!ids || ids.length === 0) return;
    const response = await client.request(
      updateNotifications(ids, { status })
    );
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function deleteItemFromCollection(collection, id) {
  try {
    const response = await client.request(deleteItem(collection, id));
    return handleDirectusResponse(response);
  } catch (error) {
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function deleteItemsFromCollection(collection, ids) {
  try {
    const response = await client.request(deleteItems(collection, ids));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function fetchItemsCount(collection, query) {
  try {
    const response = await client.request(aggregate(collection, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function getItemsCount(collection, query) {
  try {
    const response = await client.request(aggregate(collection, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function getDirectusField(collection, field) {
  try {
    const response = await client.request(readField(collection, field));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function getUserPermissions() {
  try {
    const response = await client.request(readUserPermissions());
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);

    let mutedError = handleDirectusResponse(error);

    throw mutedError;
  }
}

export async function getPermissionsForItem(collection, itemId) {
  try {
    const response = await client.request(
      readItemPermissions(collection, itemId),
    );

    console.log("readItemPermissions response:", response);
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function addEmployee(item, query) {
  try {
    const response = await client.request(createItem("employees", item, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function fetchEmployee(key, query) {
  try {
    const response = await client.request(readItem("employees", key, query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function updateEmployee(key, item, query) {
  try {
    const response = await client.request(
      updateItem("employees", key, item, query),
    );
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function fetchEmployees(query) {
  try {
    const response = await client.request(readItems("employees", query));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}

export async function deleteDirectusFile(id) {
  try {
    const response = await client.request(deleteFile(id));
    return handleDirectusResponse(response);
  } catch (error) {
    console.log(error);
    let mutedError = handleDirectusResponse(error);
    throw mutedError;
  }
}
